import jasonHiThereEn from "../../assets/classroom/video/jason/jason_hello_en.mp4";
import jasonHiThereId from "../../assets/classroom/video/jason/jason_hello_id.mp4";
import jasonHowEn from "../../assets/classroom/video/jason/jason_how_en.mp4";
import jasonHowId from "../../assets/classroom/video/jason/jason_how_id.mp4";
import jasonFeelFreeEn from "../../assets/classroom/video/jason/jason_feel_en.mp4";
import jasonFeelFreeId from "../../assets/classroom/video/jason/jason_feel_id.mp4";
import jasonHiEn from "../../assets/classroom/video/jason/jason_hi_en.mp4";
import jasonHiId from "../../assets/classroom/video/jason/jason_hi_id.mp4";

import emilyHiThereEn from "../../assets/classroom/video/emily/emily_hello_en.mp4";
import emilyHiThereId from "../../assets/classroom/video/emily/emily_hello_id.mp4";
import emilyHowEn from "../../assets/classroom/video/emily/emily_how_en.mp4";
import emilyHowId from "../../assets/classroom/video/emily/emily_how_id.mp4";
import emilyFeelFreeEn from "../../assets/classroom/video/emily/emily_feel_en.mp4";
import emilyFeelFreeId from "../../assets/classroom/video/emily/emily_feel_id.mp4";
import emilyHiEn from "../../assets/classroom/video/emily/emily_hi_en.mp4";
import emilyHiId from "../../assets/classroom/video/emily/emily_hi_id.mp4";

const classroomVideoConfig = {
  Jason: {
    EN: [
      {
        video: jasonHiThereEn,
        introMessage:
          "Hi there! I’m Jason, ready to help with your learning needs",
      },
      {
        video: jasonHowEn,
        introMessage: "How’s everything going with your studies today?",
      },
      {
        video: jasonFeelFreeEn,
        introMessage:
          "Feel free to ask about lessons or any topics you need help with!",
      },
      {
        video: jasonHiEn,
        introMessage: "Hi, how can I address you?",
      },
    ],
    ID: [
      {
        video: jasonHiThereId,
        introMessage:
          "Halo! Saya Jason, siap membantu dengan kebutuhan belajar Anda",
      },
      {
        video: jasonHowId,
        introMessage: "Bagaimana kinera belajar Anda hari ini?",
      },
      {
        video: jasonFeelFreeId,
        introMessage:
          "Kamu bebas bertanya tentang pelajaran atau topik apa pun!",
      },
      {
        video: jasonHiId,
        introMessage: "Halo, bagaimana saya dapat memanggil Anda?",
      },
    ],
  },
  Emily: {
    EN: [
      {
        video: emilyHiThereEn,
        introMessage:
          "Hi there! I’m Emily, ready to help with your learning needs",
      },
      {
        video: emilyHowEn,
        introMessage: "How’s everything going with your studies today?",
      },
      {
        video: emilyFeelFreeEn,
        introMessage:
          "Feel free to ask about lessons or any topics you need help with!",
      },
      {
        video: emilyHiEn,
        introMessage: "Hi, how can I address you?",
      },
    ],
    ID: [
      {
        video: emilyHiThereId,
        introMessage:
          "Halo! Saya Emily, saya siap membantu dengan kebutuhan belajar Anda",
      },
      {
        video: emilyHowId,
        introMessage: "Bagaimana Kinera belajar Anda hari ini?",
      },
      {
        video: emilyFeelFreeId,
        introMessage:
          "Kamu bebas bertanya tentang pelajaran atau topik apa pun!",
      },
      {
        video: emilyHiId,
        introMessage: "Halo, bagaimana saya dapat memanggil Anda?",
      },
    ],
  },
};

const language = sessionStorage.getItem("language") || "EN";

export const getNextStep = (currentStep, avatar) => {
  const videoList = classroomVideoConfig[avatar]?.[language] || [];
  return Math.min(currentStep + 1, videoList.length - 1);
};

export const getVideoConfig = (avatar, step) => {
  return classroomVideoConfig[avatar]?.[language]?.[step] || null;
};

export default classroomVideoConfig;
